// extracted by mini-css-extract-plugin
export default {"clipText":"clipText__2yxT0"};